import { InputField } from '../field/input.field'

export class AntTextareaField extends InputField<any> {
  type: any
  isHorizontal?: boolean = true
  row?: number
  params: object
  constructor(options: InputField<any> & { isHorizontal: boolean; row: number }) {
    super(options)
    this.selector = 'ef-ant-textarea'
    this.type = options.type || 'text'
    this.isHorizontal = options.isHorizontal == undefined ? true : options.isHorizontal
    this.row = options.row == undefined ? 3 : options.row
    this.params = options.params
  }
}
